function initMarker($marker, map) {
	const { lat, lng, icon, group, visible } = $marker.dataset;

	const latLng = {
		lat: parseFloat(lat),
		lng: parseFloat(lng),
	};
	/* global google */
	/* eslint no-undef: "error" */
	const marker = new google.maps.Marker({
		position: latLng,
		map,
		icon,
		category: group,
		visible: visible !== 'false',
		zIndex: visible === 'false' ? 1 : 999,
	});
	map.markers.push(marker);
}

function setVisible(map, group, visible) {
	map.markers.forEach((el) => {
		if (el.category === group) {
			el.setVisible(visible);
		}
	});
}

function filterMap(map) {
	const filters = document.querySelectorAll('.js-gm-filter');

	filters.forEach((el) => {
		const filter = el;
		filter.onchange = (event) => {
			const { group } = event.currentTarget.dataset;
			if (event.target.checked) {
				setVisible(map, group, true);
			} else {
				setVisible(map, group, false);
			}
		};
	});
}

function centerMap(map) {
	const bounds = new google.maps.LatLngBounds();
	map.markers.forEach((marker) => {
		bounds.extend({
			lat: marker.position.lat(),
			lng: marker.position.lng(),
		});
	});

	if (map.markers.length === 1) {
		map.setCenter(bounds.getCenter());
	} else {
		map.fitBounds(bounds);
	}
}

function initMap($el) {
	const $markers = $el.querySelectorAll('.js-marker');
	const mapArgs = {
		zoom: parseInt($el.dataset.zoom, 0) || 16,
		mapTypeId: google.maps.MapTypeId.ROADMAP,
		disableDefaultUI: true,
		styles: [
			{
				featureType: 'water',
				elementType: 'geometry',
				stylers: [
					{
						color: '#e9e9e9',
					},
					{
						lightness: 17,
					},
				],
			},
			{
				featureType: 'landscape',
				elementType: 'geometry',
				stylers: [
					{
						color: '#f5f5f5',
					},
					{
						lightness: 20,
					},
				],
			},
			{
				featureType: 'road.highway',
				elementType: 'geometry.fill',
				stylers: [
					{
						color: '#ffffff',
					},
					{
						lightness: 17,
					},
				],
			},
			{
				featureType: 'road.highway',
				elementType: 'geometry.stroke',
				stylers: [
					{
						color: '#ffffff',
					},
					{
						lightness: 29,
					},
					{
						weight: 0.2,
					},
				],
			},
			{
				featureType: 'road.arterial',
				elementType: 'geometry',
				stylers: [
					{
						color: '#ffffff',
					},
					{
						lightness: 18,
					},
				],
			},
			{
				featureType: 'road.local',
				elementType: 'geometry',
				stylers: [
					{
						color: '#ffffff',
					},
					{
						lightness: 16,
					},
				],
			},
			{
				featureType: 'poi',
				elementType: 'geometry',
				stylers: [
					{
						color: '#f5f5f5',
					},
					{
						lightness: 21,
					},
				],
			},
			{
				featureType: 'poi.park',
				elementType: 'geometry',
				stylers: [
					{
						color: '#dedede',
					},
					{
						lightness: 21,
					},
				],
			},
			{
				elementType: 'labels.text.stroke',
				stylers: [
					{
						visibility: 'on',
					},
					{
						color: '#ffffff',
					},
					{
						lightness: 16,
					},
				],
			},
			{
				elementType: 'labels.text.fill',
				stylers: [
					{
						saturation: 36,
					},
					{
						color: '#333333',
					},
					{
						lightness: 40,
					},
				],
			},
			{
				elementType: 'labels.icon',
				stylers: [
					{
						visibility: 'off',
					},
				],
			},
			{
				featureType: 'transit',
				elementType: 'geometry',
				stylers: [
					{
						color: '#f2f2f2',
					},
					{
						lightness: 19,
					},
				],
			},
			{
				featureType: 'administrative',
				elementType: 'geometry.fill',
				stylers: [
					{
						color: '#fefefe',
					},
					{
						lightness: 20,
					},
				],
			},
			{
				featureType: 'administrative',
				elementType: 'geometry.stroke',
				stylers: [
					{
						color: '#fefefe',
					},
					{
						lightness: 17,
					},
					{
						weight: 1.2,
					},
				],
			},
		],
	};

	const map = new google.maps.Map($el, mapArgs);

	map.markers = [];
	$markers.forEach((el) => {
		initMarker(el, map);
	});

	filterMap(map);
	centerMap(map);

	window.addEventListener('resize', () => {
		centerMap(map);
	});

	return map;
}

window.addEventListener('DOMContentLoaded', () => {
	const mapDiv = document.getElementById('js-gm');
	const mapObservceConfig = {
		rootMargin: '0px',
		threshold: 0,
	};
	const mapObserve = new IntersectionObserver((els) => {
		els.forEach((el) => {
			if (el.isIntersecting) {
				initMap(mapDiv);
				mapObserve.disconnect();
			}
		});
	}, mapObservceConfig);

	mapObserve.observe(mapDiv);
});
